import { render } from "./NotFound.vue?vue&type=template&id=c486d402"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=c486d402&scopen=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__